import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useLabOrderActions() {
  const [isLoading, setLoading] = useState(false);

  // Dates are DD/MM/YYYY. `date` depends on the target status (sent, return, new expected
  // return or delivery date); `expectedReturnDate` is only sent when registering the send.
  const changeStatus = useCallback((labOrderId, status, date, expectedReturnDate) => {
    setLoading(true);
    return quarkusApi
      .patch(`/lab-orders/${labOrderId}/status`, { status, date, expectedReturnDate }, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const remove = useCallback((labOrderId) => {
    setLoading(true);
    return quarkusApi
      .delete(`/lab-orders/${labOrderId}`, authHeader())
      .finally(() => setLoading(false));
  }, []);

  return { changeStatus, remove, isLoading };
}
